// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserSettingsModal_overlay__\\+c5hY {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: 0;
  animation: UserSettingsModal_fadeIn__MxgQN 0.05s ease-out forwards;
}

.UserSettingsModal_modal__KWQur {
  background: rgba(24, 26, 27, 0.95);
  backdrop-filter: blur(15px);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.1);
  width: 90%;
  max-width: 800px;
  max-height: 85vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  color: white;
  opacity: 0;
  transform: scale(0.9);
  animation: UserSettingsModal_modalContentFadeIn__F2xV0 0.1s ease-out 0.025s forwards;
}

.UserSettingsModal_header__2pvpq {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(30, 30, 30, 0.7);
}

.UserSettingsModal_header__2pvpq h2 {
  margin: 0;
  font-size: 1.5rem;
  color: #4a9eff;
  font-weight: bold;
}

.UserSettingsModal_closeButton__B7mbj {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #ccc;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.UserSettingsModal_closeButton__B7mbj:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

.UserSettingsModal_content__TJiPC {
  flex: 1 1;
  padding: 1.5rem;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}

.UserSettingsModal_content__TJiPC::-webkit-scrollbar {
  width: 6px;
}

.UserSettingsModal_content__TJiPC::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.UserSettingsModal_content__TJiPC::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}

.UserSettingsModal_content__TJiPC::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

.UserSettingsModal_section__AlVW1 {
  margin-bottom: 2rem;
}

.UserSettingsModal_section__AlVW1 h3 {
  margin: 0 0 1rem 0;
  font-size: 1.2rem;
  color: white;
  font-weight: 600;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 0.5rem;
}

.UserSettingsModal_changePasswordButton__5kp\\+T {
  background: #4a9eff;
  border: none;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s;
  display: inline-block;
}

.UserSettingsModal_changePasswordButton__5kp\\+T:hover {
  background: #3a8aff;
  transform: translateY(-1px);
}

/* Admin-specific styles */
.UserSettingsModal_createUserForm__ZC6HP {
  background: rgba(40, 40, 40, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  padding: 1.5rem;
  margin-bottom: 1rem;
}

.UserSettingsModal_inputGroup__4tJf5 {
  margin-bottom: 1rem;
}

.UserSettingsModal_inputGroup__4tJf5 label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #ccc;
  font-size: 0.9rem;
}

.UserSettingsModal_inputGroup__4tJf5 input,
.UserSettingsModal_inputGroup__4tJf5 select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.3);
  color: white;
  font-size: 0.9rem;
  box-sizing: border-box;
}

.UserSettingsModal_inputGroup__4tJf5 input:focus,
.UserSettingsModal_inputGroup__4tJf5 select:focus {
  outline: none;
  border-color: #4a9eff;
  box-shadow: 0 0 0 2px rgba(74, 158, 255, 0.2);
}

.UserSettingsModal_inputGroup__4tJf5 input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.UserSettingsModal_createButton__8NQ06 {
  background: #4a9eff;
  border: none;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s;
  width: 100%;
}

.UserSettingsModal_createButton__8NQ06:hover {
  background: #3a8aff;
  transform: translateY(-1px);
}

.UserSettingsModal_createButton__8NQ06:disabled {
  background: #666;
  cursor: not-allowed;
  transform: none;
}

.UserSettingsModal_usersList__wGh6u {
  background: rgba(40, 40, 40, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  overflow: hidden;
}

.UserSettingsModal_usersHeader__CbtvE {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 2fr;
  gap: 1rem;
  padding: 1rem;
  background: rgba(30, 30, 30, 0.7);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  font-weight: 600;
  color: #4a9eff;
  font-size: 0.9rem;
}

.UserSettingsModal_userRow__FWDiZ {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 2fr;
  gap: 1rem;
  padding: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  align-items: center;
  transition: background-color 0.2s;
}

.UserSettingsModal_userRow__FWDiZ:hover {
  background: rgba(255, 255, 255, 0.02);
}

.UserSettingsModal_userRow__FWDiZ:last-child {
  border-bottom: none;
}

.UserSettingsModal_username__s5Ftb {
  font-weight: 500;
  color: white;
}

.UserSettingsModal_role__s\\+y33 {
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-align: center;
}

.UserSettingsModal_adminRole__nMz6T {
  background: rgba(74, 158, 255, 0.2);
  color: #4a9eff;
  border: 1px solid rgba(74, 158, 255, 0.3);
}

.UserSettingsModal_userRole__cNzPh {
  background: rgba(255, 255, 255, 0.1);
  color: #ccc;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.UserSettingsModal_status__CgbQI {
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-align: center;
}

.UserSettingsModal_active__QU33v {
  background: rgba(76, 175, 80, 0.2);
  color: #4caf50;
  border: 1px solid rgba(76, 175, 80, 0.3);
}

.UserSettingsModal_inactive__FpWKH {
  background: rgba(244, 67, 54, 0.2);
  color: #f44336;
  border: 1px solid rgba(244, 67, 54, 0.3);
}

.UserSettingsModal_actions__Msmko {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
}

.UserSettingsModal_actionButton__vBW6q {
  padding: 0.4rem 0.8rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.75rem;
  font-weight: 500;
  transition: all 0.2s;
}

.UserSettingsModal_activateButton__s\\+EVp {
  background: rgba(76, 175, 80, 0.8);
  color: white;
}

.UserSettingsModal_activateButton__s\\+EVp:hover {
  background: #4caf50;
}

.UserSettingsModal_deactivateButton__P\\+MSC {
  background: rgba(255, 152, 0, 0.8);
  color: white;
}

.UserSettingsModal_deactivateButton__P\\+MSC:hover {
  background: #ff9800;
}

.UserSettingsModal_deleteButton__Eh94n {
  background: rgba(244, 67, 54, 0.8);
  color: white;
}

.UserSettingsModal_deleteButton__Eh94n:hover {
  background: #f44336;
}

.UserSettingsModal_actionButton__vBW6q:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.UserSettingsModal_error__kjlCR {
  background-color: rgba(244, 67, 54, 0.1);
  color: #f44336;
  border: 1px solid rgba(244, 67, 54, 0.3);
  padding: 0.75rem;
  border-radius: 4px;
  margin-bottom: 1rem;
  font-size: 0.9rem;
}

.UserSettingsModal_success__kEugN {
  background-color: rgba(76, 175, 80, 0.1);
  color: #4caf50;
  border: 1px solid rgba(76, 175, 80, 0.3);
  padding: 0.75rem;
  border-radius: 4px;
  margin-top: 1rem;
  font-size: 0.9rem;
}

.UserSettingsModal_footer__kDQYK {
  display: flex;
  justify-content: flex-end;
  padding: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(30, 30, 30, 0.7);
}

.UserSettingsModal_closeFooterButton__Gigq2 {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
}

.UserSettingsModal_closeFooterButton__Gigq2:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
}

/* Background Selection Styles */
.UserSettingsModal_backgroundGrid__ADEcM {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.UserSettingsModal_backgroundItem__B2oGv {
  position: relative;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(40, 40, 40, 0.5);
}

.UserSettingsModal_backgroundItem__B2oGv:hover {
  border-color: #4a9eff;
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(74, 158, 255, 0.3);
}

.UserSettingsModal_backgroundItem__B2oGv.UserSettingsModal_selected__62lsG {
  border-color: #4a9eff;
  border-width: 3px;
  box-shadow: 0 0 20px rgba(74, 158, 255, 0.5);
}

.UserSettingsModal_backgroundPreview__LZSBI {
  width: 100%;
  height: 150px;
  object-fit: cover;
  display: block;
}

.UserSettingsModal_backgroundName__mdC9R {
  padding: 0.75rem;
  text-align: center;
  font-size: 0.85rem;
  color: #ccc;
  background: rgba(0, 0, 0, 0.5);
  word-break: break-word;
}

.UserSettingsModal_selectedBadge__8\\+iWD {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #4a9eff;
  color: white;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

@media (max-width: 768px) {
  .UserSettingsModal_modal__KWQur {
    width: 95%;
    max-height: 90vh;
  }

  .UserSettingsModal_header__2pvpq,
  .UserSettingsModal_content__TJiPC,
  .UserSettingsModal_footer__kDQYK {
    padding: 1rem;
  }

  .UserSettingsModal_header__2pvpq h2 {
    font-size: 1.3rem;
  }

  .UserSettingsModal_backgroundGrid__ADEcM {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 0.75rem;
  }

  .UserSettingsModal_backgroundPreview__LZSBI {
    height: 120px;
  }

  .UserSettingsModal_backgroundName__mdC9R {
    font-size: 0.75rem;
    padding: 0.5rem;
  }

  .UserSettingsModal_usersHeader__CbtvE,
  .UserSettingsModal_userRow__FWDiZ {
    grid-template-columns: 1fr;
    gap: 0.5rem;
    text-align: center;
  }

  .UserSettingsModal_actions__Msmko {
    justify-content: center;
  }

  .UserSettingsModal_createButton__8NQ06 {
    font-size: 1rem;
    padding: 1rem;
  }
}

/* Animations */
@keyframes UserSettingsModal_fadeIn__MxgQN {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes UserSettingsModal_modalContentFadeIn__F2xV0 {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes UserSettingsModal_fadeOut__fWUeo {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes UserSettingsModal_modalContentFadeOut__8Rt0a {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.9);
  }
}

/* Brightness Control */
.UserSettingsModal_brightnessControl__MtofI {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 1rem 0;
}

.UserSettingsModal_brightnessSlider__uy6G4 {
  flex: 1 1;
  height: 6px;
  border-radius: 3px;
  background: linear-gradient(to right, #000 0%, #888 50%, #fff 100%);
  outline: none;
  appearance: none;
  cursor: pointer;
}

.UserSettingsModal_brightnessSlider__uy6G4::-webkit-slider-thumb {
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #4a9eff;
  cursor: pointer;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}

.UserSettingsModal_brightnessSlider__uy6G4::-webkit-slider-thumb:hover {
  background: #3a8aff;
  transform: scale(1.1);
}

.UserSettingsModal_brightnessSlider__uy6G4::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #4a9eff;
  cursor: pointer;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  -moz-transition: all 0.2s;
  transition: all 0.2s;
}

.UserSettingsModal_brightnessSlider__uy6G4::-moz-range-thumb:hover {
  background: #3a8aff;
  transform: scale(1.1);
}

.UserSettingsModal_brightnessValue__7BWzn {
  min-width: 50px;
  text-align: right;
  font-weight: bold;
  color: #4a9eff;
  font-size: 1rem;
}

.UserSettingsModal_brightnessHint__StC0U {
  margin: 0.5rem 0 0 0;
  font-size: 0.85rem;
  color: #999;
  font-style: italic;
}

/* Zoho Email Styles */
.UserSettingsModal_sectionHint__dHDYG {
  margin: 0 0 1rem 0;
  font-size: 0.85rem;
  color: #999;
  line-height: 1.4;
}

.UserSettingsModal_zohoEmailContainer__cxIg4 {
  display: flex;
  gap: 10px;
  align-items: center;
}

.UserSettingsModal_zohoEmailInput__vSvUo {
  flex: 1 1;
  padding: 0.75rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.3);
  color: white;
  font-size: 0.9rem;
  box-sizing: border-box;
}

.UserSettingsModal_zohoEmailInput__vSvUo:focus {
  outline: none;
  border-color: #4a9eff;
  box-shadow: 0 0 0 2px rgba(74, 158, 255, 0.2);
}

.UserSettingsModal_zohoEmailInput__vSvUo::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.UserSettingsModal_zohoEmailButton__4VtpG {
  background: #4a9eff;
  border: none;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s;
  white-space: nowrap;
}

.UserSettingsModal_zohoEmailButton__4VtpG:hover {
  background: #3a8aff;
}

.UserSettingsModal_zohoEmailButton__4VtpG:disabled {
  background: #666;
  cursor: not-allowed;
}

.UserSettingsModal_zohoEmailStatus__K3sPL {
  margin-top: 0.75rem;
  font-size: 0.85rem;
  color: #4caf50;
}

/* Zoho Books Verbindung */
.UserSettingsModal_zohoConfigStatus__J8Lom {
  margin: 0 0 1rem 0;
  font-size: 0.85rem;
  line-height: 1.5;
}

.UserSettingsModal_zohoConfigStatusOk__E-r-F {
  color: #4caf50;
}

.UserSettingsModal_zohoConfigStatusError__kUeU7 {
  color: #f44336;
}

.UserSettingsModal_zohoButtonRow__3h2uc {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

/* LLM Settings Styles */
.UserSettingsModal_llmSettings__ZpLDc {
  background: rgba(40, 40, 40, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  padding: 1.5rem;
}

.UserSettingsModal_llmModeSection__qs6sJ {
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.UserSettingsModal_checkboxLabel__QOYrA {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
  cursor: pointer;
  color: #ccc;
  font-size: 0.9rem;
}

.UserSettingsModal_checkboxLabel__QOYrA input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #4a9eff;
  cursor: pointer;
}

.UserSettingsModal_llmSubsection__1XS0A {
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 1rem;
}

.UserSettingsModal_llmSubsection__1XS0A h4 {
  margin: 0 0 1rem 0;
  font-size: 1rem;
  color: #4a9eff;
  font-weight: 500;
}

.UserSettingsModal_testButton__0PzT2 {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
  transition: all 0.2s;
  margin-top: 0.5rem;
}

.UserSettingsModal_testButton__0PzT2:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.2);
  border-color: #4a9eff;
}

.UserSettingsModal_testButton__0PzT2:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.UserSettingsModal_apiKeyDisplay__uv3zM {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.5rem;
  padding: 0.5rem;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}

.UserSettingsModal_maskedKey__0warg {
  font-family: monospace;
  color: #4caf50;
  font-size: 0.9rem;
}

.UserSettingsModal_removeKeyButton__Ns2D3 {
  background: rgba(244, 67, 54, 0.2);
  border: 1px solid rgba(244, 67, 54, 0.4);
  color: #f44336;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.75rem;
  transition: all 0.2s;
}

.UserSettingsModal_removeKeyButton__Ns2D3:hover {
  background: rgba(244, 67, 54, 0.4);
}

.UserSettingsModal_saveLLMButton__KnisQ {
  background: #4a9eff;
  border: none;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s;
  width: 100%;
  margin-top: 1rem;
}

.UserSettingsModal_saveLLMButton__KnisQ:hover:not(:disabled) {
  background: #3a8aff;
  transform: translateY(-1px);
}

.UserSettingsModal_saveLLMButton__KnisQ:disabled {
  background: #666;
  cursor: not-allowed;
  transform: none;
}

/* Provider List Styles */
.UserSettingsModal_providerList__tQQxJ {
  margin-bottom: 1rem;
}

.UserSettingsModal_providerItem__mBZOl {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  margin-bottom: 0.75rem;
  transition: all 0.2s;
}

.UserSettingsModal_providerItem__mBZOl:hover {
  background: rgba(0, 0, 0, 0.3);
  border-color: rgba(255, 255, 255, 0.2);
}

.UserSettingsModal_providerItem__mBZOl.UserSettingsModal_activeProvider__8YFM0 {
  border-color: rgba(76, 175, 80, 0.5);
  background: rgba(76, 175, 80, 0.1);
}

.UserSettingsModal_providerInfo__9NaZb {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.UserSettingsModal_providerName__vE8W3 {
  font-weight: 600;
  color: white;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.UserSettingsModal_activeBadge__GXWCy {
  background: rgba(76, 175, 80, 0.3);
  color: #4caf50;
  padding: 0.2rem 0.5rem;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
  border: 1px solid rgba(76, 175, 80, 0.5);
}

.UserSettingsModal_providerDetails__nOdRm {
  color: #888;
  font-size: 0.85rem;
}

.UserSettingsModal_providerActions__ZODFE {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.UserSettingsModal_activateButton__s\\+EVp {
  background: rgba(76, 175, 80, 0.2);
  border: 1px solid rgba(76, 175, 80, 0.4);
  color: #4caf50;
  padding: 0.4rem 0.8rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 500;
  transition: all 0.2s;
}

.UserSettingsModal_activateButton__s\\+EVp:hover:not(:disabled) {
  background: rgba(76, 175, 80, 0.4);
}

.UserSettingsModal_editButton__qCJaX {
  background: rgba(74, 158, 255, 0.2);
  border: 1px solid rgba(74, 158, 255, 0.4);
  color: #4a9eff;
  padding: 0.4rem 0.8rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 500;
  transition: all 0.2s;
}

.UserSettingsModal_editButton__qCJaX:hover:not(:disabled) {
  background: rgba(74, 158, 255, 0.4);
}

.UserSettingsModal_editButton__qCJaX:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.UserSettingsModal_deleteProviderButton__p-ikH {
  background: rgba(244, 67, 54, 0.2);
  border: 1px solid rgba(244, 67, 54, 0.4);
  color: #f44336;
  padding: 0.4rem 0.8rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 500;
  transition: all 0.2s;
}

.UserSettingsModal_deleteProviderButton__p-ikH:hover:not(:disabled) {
  background: rgba(244, 67, 54, 0.4);
}

.UserSettingsModal_noProviders__QmQL2 {
  color: #888;
  font-style: italic;
  text-align: center;
  padding: 1rem;
}

.UserSettingsModal_addProviderButton__95cu0 {
  background: rgba(74, 158, 255, 0.2);
  border: 1px dashed rgba(74, 158, 255, 0.5);
  color: #4a9eff;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s;
  width: 100%;
  text-align: center;
}

.UserSettingsModal_addProviderButton__95cu0:hover {
  background: rgba(74, 158, 255, 0.3);
  border-style: solid;
}

.UserSettingsModal_addProviderForm__wuOOI {
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(74, 158, 255, 0.3);
  border-radius: 6px;
  padding: 1.5rem;
}

.UserSettingsModal_addProviderForm__wuOOI h4 {
  margin: 0 0 1rem 0;
  color: #4a9eff;
  font-size: 1rem;
}

.UserSettingsModal_formButtons__TlGob {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

.UserSettingsModal_formButtons__TlGob .UserSettingsModal_createButton__8NQ06 {
  flex: 1 1;
}

.UserSettingsModal_cancelButton__r3tO5 {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #ccc;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
}

.UserSettingsModal_cancelButton__r3tO5:hover {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

/* Closing animations */
.UserSettingsModal_overlay__\\+c5hY.UserSettingsModal_closing__NU-wB {
  animation: UserSettingsModal_fadeOut__fWUeo 0.15s ease-in forwards;
}

.UserSettingsModal_modal__KWQur.UserSettingsModal_closing__NU-wB {
  animation: UserSettingsModal_modalContentFadeOut__8Rt0a 0.15s ease-in forwards;
}

/* AI Prompts Section Styles */
.UserSettingsModal_aiPromptButtons__Anmui {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.UserSettingsModal_aiPromptButton__\\+VtYn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(40, 40, 40, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 0.75rem 1.25rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
}

.UserSettingsModal_aiPromptButton__\\+VtYn:hover {
  background: rgba(74, 158, 255, 0.2);
  border-color: #4a9eff;
}

.UserSettingsModal_aiPromptButton__\\+VtYn i {
  font-size: 1.1rem;
  color: #4a9eff;
}

.UserSettingsModal_customBadge__knoup {
  background: #4a9eff;
  color: white;
  font-size: 0.7rem;
  padding: 0.2rem 0.5rem;
  border-radius: 10px;
  margin-left: 0.5rem;
}

/* AI Prompt Edit Modal */
.UserSettingsModal_promptModalOverlay__ifR91 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
  animation: UserSettingsModal_fadeIn__MxgQN 0.15s ease-out forwards;
}

.UserSettingsModal_promptModal__aKFVp {
  background: rgba(24, 26, 27, 0.98);
  backdrop-filter: blur(15px);
  border-radius: 8px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.15);
  width: 90%;
  max-width: 900px;
  max-height: 85vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  color: white;
  animation: UserSettingsModal_modalContentFadeIn__F2xV0 0.2s ease-out forwards;
}

.UserSettingsModal_promptModalHeader__LX-0t {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(30, 30, 30, 0.7);
}

.UserSettingsModal_promptModalHeader__LX-0t h3 {
  margin: 0;
  font-size: 1.25rem;
  color: #4a9eff;
  font-weight: 600;
}

.UserSettingsModal_promptModalContent__D9qza {
  flex: 1 1;
  padding: 1.5rem;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}

.UserSettingsModal_promptModalContent__D9qza::-webkit-scrollbar {
  width: 6px;
}

.UserSettingsModal_promptModalContent__D9qza::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.UserSettingsModal_promptModalContent__D9qza::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}

.UserSettingsModal_defaultPromptSection__KD4x6,
.UserSettingsModal_customPromptSection__iuqVZ {
  margin-bottom: 1.5rem;
}

.UserSettingsModal_defaultPromptSection__KD4x6 label,
.UserSettingsModal_customPromptSection__iuqVZ label {
  display: block;
  margin-bottom: 0.75rem;
  font-weight: 500;
  color: #ccc;
  font-size: 0.9rem;
}

.UserSettingsModal_defaultPromptText__\\+Az-D {
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  padding: 1rem;
  font-family: 'Consolas', 'Monaco', monospace;
  font-size: 0.8rem;
  line-height: 1.5;
  color: #aaa;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-height: 200px;
  overflow-y: auto;
}

.UserSettingsModal_customPromptTextarea__C7EYP {
  width: 100%;
  padding: 1rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  background-color: rgba(0, 0, 0, 0.3);
  color: white;
  font-size: 0.9rem;
  font-family: inherit;
  line-height: 1.5;
  resize: vertical;
  min-height: 120px;
  box-sizing: border-box;
}

.UserSettingsModal_customPromptTextarea__C7EYP:focus {
  outline: none;
  border-color: #4a9eff;
  box-shadow: 0 0 0 2px rgba(74, 158, 255, 0.2);
}

.UserSettingsModal_customPromptTextarea__C7EYP::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.UserSettingsModal_promptHint__tc0pW {
  margin-top: 0.5rem;
  font-size: 0.8rem;
  color: #888;
  font-style: italic;
}

.UserSettingsModal_promptModalFooter__42UST {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(30, 30, 30, 0.7);
}

.UserSettingsModal_savePromptButton__ruZIk {
  background: #4a9eff;
  border: none;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s;
}

.UserSettingsModal_savePromptButton__ruZIk:hover {
  background: #3a8aff;
}

.UserSettingsModal_savePromptButton__ruZIk:disabled,
.UserSettingsModal_promptModalFooter__42UST .UserSettingsModal_cancelButton__r3tO5:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* External API Key Section Styles */
.UserSettingsModal_apiKeyContainer__alnpi {
  background: rgba(40, 40, 40, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  padding: 1.25rem;
}

.UserSettingsModal_apiKeyStatus__coBah {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.UserSettingsModal_apiKeyLabel__h8rdQ {
  color: #ccc;
  font-size: 0.9rem;
}

.UserSettingsModal_apiKeyActive__T0sBO {
  color: #4caf50;
  font-weight: 500;
  font-size: 0.9rem;
}

.UserSettingsModal_apiKeyInactive__yxiKN {
  color: #888;
  font-style: italic;
  font-size: 0.9rem;
}

.UserSettingsModal_generatedKeyBox__A14ll {
  background: rgba(155, 89, 182, 0.15);
  border: 1px solid rgba(155, 89, 182, 0.3);
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 1rem;
}

.UserSettingsModal_generatedKeyLabel__LZNzx {
  margin: 0 0 0.75rem 0;
  color: #9B59B6;
  font-weight: 500;
  font-size: 0.9rem;
}

.UserSettingsModal_generatedKeyValue__\\+Ni-e {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: rgba(0, 0, 0, 0.3);
  padding: 0.75rem;
  border-radius: 4px;
  overflow: hidden;
}

.UserSettingsModal_generatedKeyValue__\\+Ni-e code {
  flex: 1 1;
  font-family: 'Consolas', 'Monaco', monospace;
  font-size: 0.85rem;
  color: #fff;
  word-break: break-all;
  -webkit-user-select: all;
          user-select: all;
}

.UserSettingsModal_copyButton__OAliP {
  background: rgba(155, 89, 182, 0.3);
  border: 1px solid rgba(155, 89, 182, 0.5);
  color: #9B59B6;
  padding: 0.5rem 0.75rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
  flex-shrink: 0;
}

.UserSettingsModal_copyButton__OAliP:hover {
  background: rgba(155, 89, 182, 0.5);
  color: white;
}

.UserSettingsModal_generateKeyButton__Bcx\\+M {
  background: rgba(155, 89, 182, 0.3);
  border: 1px solid rgba(155, 89, 182, 0.5);
  color: #9B59B6;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s;
  width: 100%;
}

.UserSettingsModal_generateKeyButton__Bcx\\+M:hover:not(:disabled) {
  background: rgba(155, 89, 182, 0.5);
  color: white;
}

.UserSettingsModal_generateKeyButton__Bcx\\+M:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .UserSettingsModal_aiPromptButtons__Anmui {
    flex-direction: column;
  }

  .UserSettingsModal_aiPromptButton__\\+VtYn {
    width: 100%;
    justify-content: center;
  }

  .UserSettingsModal_promptModal__aKFVp {
    width: 95%;
    max-height: 90vh;
  }

  .UserSettingsModal_promptModalHeader__LX-0t,
  .UserSettingsModal_promptModalContent__D9qza,
  .UserSettingsModal_promptModalFooter__42UST {
    padding: 1rem;
  }

  .UserSettingsModal_generatedKeyValue__\\+Ni-e {
    flex-direction: column;
    align-items: stretch;
  }

  .UserSettingsModal_generatedKeyValue__\\+Ni-e code {
    margin-bottom: 0.5rem;
  }

  .UserSettingsModal_copyButton__OAliP {
    width: 100%;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UserSettingsModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,kEAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,kBAAkB;EAClB,yCAAyC;EACzC,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,oFAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,iDAAiD;EACjD,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,iDAAiD;EACjD,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,aAAa;EACb,iCAAiC;EACjC,iDAAiD;EACjD,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,aAAa;EACb,kDAAkD;EAClD,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,8CAA8C;EAC9C,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,4DAA4D;IAC5D,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;IAEE,0BAA0B;IAC1B,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,kBAAkB;EAClB,mEAAmE;EACnE,aAAa;EAEb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,wCAAwC;EACxC,4BAAoB;EAApB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,wCAAwC;EACxC,yBAAoB;EAApB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,0CAA0C;EAC1C,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;EAC1C,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,kEAAyC;AAC3C;;AAEA;EACE,8EAAqD;AACvD;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iCAAiC;EACjC,0CAA0C;EAC1C,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kEAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,kBAAkB;EAClB,yCAAyC;EACzC,2CAA2C;EAC3C,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,6EAAoD;AACtD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;EACjD,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,4CAA4C;EAC5C,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,uBAAuB;EACvB,8CAA8C;EAC9C,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,4CAA4C;EAC5C,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,wBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":[".overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.8);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n  opacity: 0;\r\n  animation: fadeIn 0.05s ease-out forwards;\r\n}\r\n\r\n.modal {\r\n  background: rgba(24, 26, 27, 0.95);\r\n  backdrop-filter: blur(15px);\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.7);\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n  width: 90%;\r\n  max-width: 800px;\r\n  max-height: 85vh;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  color: white;\r\n  opacity: 0;\r\n  transform: scale(0.9);\r\n  animation: modalContentFadeIn 0.1s ease-out 0.025s forwards;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 1.5rem;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\r\n  background: rgba(30, 30, 30, 0.7);\r\n}\r\n\r\n.header h2 {\r\n  margin: 0;\r\n  font-size: 1.5rem;\r\n  color: #4a9eff;\r\n  font-weight: bold;\r\n}\r\n\r\n.closeButton {\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.5rem;\r\n  cursor: pointer;\r\n  color: #ccc;\r\n  width: 30px;\r\n  height: 30px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.closeButton:hover {\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n  color: white;\r\n}\r\n\r\n.content {\r\n  flex: 1;\r\n  padding: 1.5rem;\r\n  overflow-y: auto;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;\r\n}\r\n\r\n.content::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.content::-webkit-scrollbar-track {\r\n  background: rgba(0, 0, 0, 0.2);\r\n  border-radius: 3px;\r\n}\r\n\r\n.content::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.3);\r\n  border-radius: 3px;\r\n}\r\n\r\n.content::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.section {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.section h3 {\r\n  margin: 0 0 1rem 0;\r\n  font-size: 1.2rem;\r\n  color: white;\r\n  font-weight: 600;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\r\n  padding-bottom: 0.5rem;\r\n}\r\n\r\n.changePasswordButton {\r\n  background: #4a9eff;\r\n  border: none;\r\n  color: white;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n  display: inline-block;\r\n}\r\n\r\n.changePasswordButton:hover {\r\n  background: #3a8aff;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n/* Admin-specific styles */\r\n.createUserForm {\r\n  background: rgba(40, 40, 40, 0.5);\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n  border-radius: 6px;\r\n  padding: 1.5rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.inputGroup {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.inputGroup label {\r\n  display: block;\r\n  margin-bottom: 0.5rem;\r\n  font-weight: 500;\r\n  color: #ccc;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.inputGroup input,\r\n.inputGroup select {\r\n  width: 100%;\r\n  padding: 0.75rem;\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  border-radius: 4px;\r\n  background-color: rgba(0, 0, 0, 0.3);\r\n  color: white;\r\n  font-size: 0.9rem;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.inputGroup input:focus,\r\n.inputGroup select:focus {\r\n  outline: none;\r\n  border-color: #4a9eff;\r\n  box-shadow: 0 0 0 2px rgba(74, 158, 255, 0.2);\r\n}\r\n\r\n.inputGroup input::placeholder {\r\n  color: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.createButton {\r\n  background: #4a9eff;\r\n  border: none;\r\n  color: white;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n  width: 100%;\r\n}\r\n\r\n.createButton:hover {\r\n  background: #3a8aff;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.createButton:disabled {\r\n  background: #666;\r\n  cursor: not-allowed;\r\n  transform: none;\r\n}\r\n\r\n.usersList {\r\n  background: rgba(40, 40, 40, 0.5);\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n}\r\n\r\n.usersHeader {\r\n  display: grid;\r\n  grid-template-columns: 2fr 1fr 1fr 2fr;\r\n  gap: 1rem;\r\n  padding: 1rem;\r\n  background: rgba(30, 30, 30, 0.7);\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\r\n  font-weight: 600;\r\n  color: #4a9eff;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.userRow {\r\n  display: grid;\r\n  grid-template-columns: 2fr 1fr 1fr 2fr;\r\n  gap: 1rem;\r\n  padding: 1rem;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\r\n  align-items: center;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.userRow:hover {\r\n  background: rgba(255, 255, 255, 0.02);\r\n}\r\n\r\n.userRow:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.username {\r\n  font-weight: 500;\r\n  color: white;\r\n}\r\n\r\n.role {\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: 12px;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  text-align: center;\r\n}\r\n\r\n.adminRole {\r\n  background: rgba(74, 158, 255, 0.2);\r\n  color: #4a9eff;\r\n  border: 1px solid rgba(74, 158, 255, 0.3);\r\n}\r\n\r\n.userRole {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  color: #ccc;\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.status {\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: 12px;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  text-align: center;\r\n}\r\n\r\n.active {\r\n  background: rgba(76, 175, 80, 0.2);\r\n  color: #4caf50;\r\n  border: 1px solid rgba(76, 175, 80, 0.3);\r\n}\r\n\r\n.inactive {\r\n  background: rgba(244, 67, 54, 0.2);\r\n  color: #f44336;\r\n  border: 1px solid rgba(244, 67, 54, 0.3);\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.actionButton {\r\n  padding: 0.4rem 0.8rem;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.75rem;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.activateButton {\r\n  background: rgba(76, 175, 80, 0.8);\r\n  color: white;\r\n}\r\n\r\n.activateButton:hover {\r\n  background: #4caf50;\r\n}\r\n\r\n.deactivateButton {\r\n  background: rgba(255, 152, 0, 0.8);\r\n  color: white;\r\n}\r\n\r\n.deactivateButton:hover {\r\n  background: #ff9800;\r\n}\r\n\r\n.deleteButton {\r\n  background: rgba(244, 67, 54, 0.8);\r\n  color: white;\r\n}\r\n\r\n.deleteButton:hover {\r\n  background: #f44336;\r\n}\r\n\r\n.actionButton:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.error {\r\n  background-color: rgba(244, 67, 54, 0.1);\r\n  color: #f44336;\r\n  border: 1px solid rgba(244, 67, 54, 0.3);\r\n  padding: 0.75rem;\r\n  border-radius: 4px;\r\n  margin-bottom: 1rem;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.success {\r\n  background-color: rgba(76, 175, 80, 0.1);\r\n  color: #4caf50;\r\n  border: 1px solid rgba(76, 175, 80, 0.3);\r\n  padding: 0.75rem;\r\n  border-radius: 4px;\r\n  margin-top: 1rem;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  padding: 1.5rem;\r\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\r\n  background: rgba(30, 30, 30, 0.7);\r\n}\r\n\r\n.closeFooterButton {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  color: white;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.closeFooterButton:hover {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border-color: rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n/* Background Selection Styles */\r\n.backgroundGrid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\r\n  gap: 1rem;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.backgroundItem {\r\n  position: relative;\r\n  border: 2px solid rgba(255, 255, 255, 0.2);\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  background: rgba(40, 40, 40, 0.5);\r\n}\r\n\r\n.backgroundItem:hover {\r\n  border-color: #4a9eff;\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 4px 12px rgba(74, 158, 255, 0.3);\r\n}\r\n\r\n.backgroundItem.selected {\r\n  border-color: #4a9eff;\r\n  border-width: 3px;\r\n  box-shadow: 0 0 20px rgba(74, 158, 255, 0.5);\r\n}\r\n\r\n.backgroundPreview {\r\n  width: 100%;\r\n  height: 150px;\r\n  object-fit: cover;\r\n  display: block;\r\n}\r\n\r\n.backgroundName {\r\n  padding: 0.75rem;\r\n  text-align: center;\r\n  font-size: 0.85rem;\r\n  color: #ccc;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  word-break: break-word;\r\n}\r\n\r\n.selectedBadge {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  background: #4a9eff;\r\n  color: white;\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 1.2rem;\r\n  font-weight: bold;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .modal {\r\n    width: 95%;\r\n    max-height: 90vh;\r\n  }\r\n\r\n  .header,\r\n  .content,\r\n  .footer {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .header h2 {\r\n    font-size: 1.3rem;\r\n  }\r\n\r\n  .backgroundGrid {\r\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\r\n    gap: 0.75rem;\r\n  }\r\n\r\n  .backgroundPreview {\r\n    height: 120px;\r\n  }\r\n\r\n  .backgroundName {\r\n    font-size: 0.75rem;\r\n    padding: 0.5rem;\r\n  }\r\n\r\n  .usersHeader,\r\n  .userRow {\r\n    grid-template-columns: 1fr;\r\n    gap: 0.5rem;\r\n    text-align: center;\r\n  }\r\n\r\n  .actions {\r\n    justify-content: center;\r\n  }\r\n\r\n  .createButton {\r\n    font-size: 1rem;\r\n    padding: 1rem;\r\n  }\r\n}\r\n\r\n/* Animations */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes modalContentFadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.9);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n@keyframes fadeOut {\r\n  from {\r\n    opacity: 1;\r\n  }\r\n  to {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n@keyframes modalContentFadeOut {\r\n  from {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n  to {\r\n    opacity: 0;\r\n    transform: scale(0.9);\r\n  }\r\n}\r\n\r\n/* Brightness Control */\r\n.brightnessControl {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  margin: 1rem 0;\r\n}\r\n\r\n.brightnessSlider {\r\n  flex: 1;\r\n  height: 6px;\r\n  border-radius: 3px;\r\n  background: linear-gradient(to right, #000 0%, #888 50%, #fff 100%);\r\n  outline: none;\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.brightnessSlider::-webkit-slider-thumb {\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 50%;\r\n  background: #4a9eff;\r\n  cursor: pointer;\r\n  border: 2px solid white;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\r\n  transition: all 0.2s;\r\n}\r\n\r\n.brightnessSlider::-webkit-slider-thumb:hover {\r\n  background: #3a8aff;\r\n  transform: scale(1.1);\r\n}\r\n\r\n.brightnessSlider::-moz-range-thumb {\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 50%;\r\n  background: #4a9eff;\r\n  cursor: pointer;\r\n  border: 2px solid white;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\r\n  transition: all 0.2s;\r\n}\r\n\r\n.brightnessSlider::-moz-range-thumb:hover {\r\n  background: #3a8aff;\r\n  transform: scale(1.1);\r\n}\r\n\r\n.brightnessValue {\r\n  min-width: 50px;\r\n  text-align: right;\r\n  font-weight: bold;\r\n  color: #4a9eff;\r\n  font-size: 1rem;\r\n}\r\n\r\n.brightnessHint {\r\n  margin: 0.5rem 0 0 0;\r\n  font-size: 0.85rem;\r\n  color: #999;\r\n  font-style: italic;\r\n}\r\n\r\n/* Zoho Email Styles */\r\n.sectionHint {\r\n  margin: 0 0 1rem 0;\r\n  font-size: 0.85rem;\r\n  color: #999;\r\n  line-height: 1.4;\r\n}\r\n\r\n.zohoEmailContainer {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n}\r\n\r\n.zohoEmailInput {\r\n  flex: 1;\r\n  padding: 0.75rem;\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  border-radius: 4px;\r\n  background-color: rgba(0, 0, 0, 0.3);\r\n  color: white;\r\n  font-size: 0.9rem;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.zohoEmailInput:focus {\r\n  outline: none;\r\n  border-color: #4a9eff;\r\n  box-shadow: 0 0 0 2px rgba(74, 158, 255, 0.2);\r\n}\r\n\r\n.zohoEmailInput::placeholder {\r\n  color: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.zohoEmailButton {\r\n  background: #4a9eff;\r\n  border: none;\r\n  color: white;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n  white-space: nowrap;\r\n}\r\n\r\n.zohoEmailButton:hover {\r\n  background: #3a8aff;\r\n}\r\n\r\n.zohoEmailButton:disabled {\r\n  background: #666;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.zohoEmailStatus {\r\n  margin-top: 0.75rem;\r\n  font-size: 0.85rem;\r\n  color: #4caf50;\r\n}\r\n\r\n/* Zoho Books Verbindung */\r\n.zohoConfigStatus {\r\n  margin: 0 0 1rem 0;\r\n  font-size: 0.85rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.zohoConfigStatusOk {\r\n  color: #4caf50;\r\n}\r\n\r\n.zohoConfigStatusError {\r\n  color: #f44336;\r\n}\r\n\r\n.zohoButtonRow {\r\n  display: flex;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* LLM Settings Styles */\r\n.llmSettings {\r\n  background: rgba(40, 40, 40, 0.5);\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n  border-radius: 6px;\r\n  padding: 1.5rem;\r\n}\r\n\r\n.llmModeSection {\r\n  margin-bottom: 1.5rem;\r\n  padding-bottom: 1rem;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.checkboxLabel {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  margin-bottom: 0.75rem;\r\n  cursor: pointer;\r\n  color: #ccc;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.checkboxLabel input[type=\"checkbox\"] {\r\n  width: 18px;\r\n  height: 18px;\r\n  accent-color: #4a9eff;\r\n  cursor: pointer;\r\n}\r\n\r\n.llmSubsection {\r\n  background: rgba(0, 0, 0, 0.2);\r\n  border: 1px solid rgba(255, 255, 255, 0.05);\r\n  border-radius: 6px;\r\n  padding: 1rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.llmSubsection h4 {\r\n  margin: 0 0 1rem 0;\r\n  font-size: 1rem;\r\n  color: #4a9eff;\r\n  font-weight: 500;\r\n}\r\n\r\n.testButton {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  color: white;\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.85rem;\r\n  transition: all 0.2s;\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.testButton:hover:not(:disabled) {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border-color: #4a9eff;\r\n}\r\n\r\n.testButton:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.apiKeyDisplay {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  margin-bottom: 0.5rem;\r\n  padding: 0.5rem;\r\n  background: rgba(0, 0, 0, 0.3);\r\n  border-radius: 4px;\r\n}\r\n\r\n.maskedKey {\r\n  font-family: monospace;\r\n  color: #4caf50;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.removeKeyButton {\r\n  background: rgba(244, 67, 54, 0.2);\r\n  border: 1px solid rgba(244, 67, 54, 0.4);\r\n  color: #f44336;\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.75rem;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.removeKeyButton:hover {\r\n  background: rgba(244, 67, 54, 0.4);\r\n}\r\n\r\n.saveLLMButton {\r\n  background: #4a9eff;\r\n  border: none;\r\n  color: white;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n  width: 100%;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.saveLLMButton:hover:not(:disabled) {\r\n  background: #3a8aff;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.saveLLMButton:disabled {\r\n  background: #666;\r\n  cursor: not-allowed;\r\n  transform: none;\r\n}\r\n\r\n/* Provider List Styles */\r\n.providerList {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.providerItem {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 1rem;\r\n  background: rgba(0, 0, 0, 0.2);\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n  border-radius: 6px;\r\n  margin-bottom: 0.75rem;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.providerItem:hover {\r\n  background: rgba(0, 0, 0, 0.3);\r\n  border-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.providerItem.activeProvider {\r\n  border-color: rgba(76, 175, 80, 0.5);\r\n  background: rgba(76, 175, 80, 0.1);\r\n}\r\n\r\n.providerInfo {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.25rem;\r\n}\r\n\r\n.providerName {\r\n  font-weight: 600;\r\n  color: white;\r\n  font-size: 1rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.activeBadge {\r\n  background: rgba(76, 175, 80, 0.3);\r\n  color: #4caf50;\r\n  padding: 0.2rem 0.5rem;\r\n  border-radius: 12px;\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  border: 1px solid rgba(76, 175, 80, 0.5);\r\n}\r\n\r\n.providerDetails {\r\n  color: #888;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.providerActions {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.activateButton {\r\n  background: rgba(76, 175, 80, 0.2);\r\n  border: 1px solid rgba(76, 175, 80, 0.4);\r\n  color: #4caf50;\r\n  padding: 0.4rem 0.8rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.8rem;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.activateButton:hover:not(:disabled) {\r\n  background: rgba(76, 175, 80, 0.4);\r\n}\r\n\r\n.editButton {\r\n  background: rgba(74, 158, 255, 0.2);\r\n  border: 1px solid rgba(74, 158, 255, 0.4);\r\n  color: #4a9eff;\r\n  padding: 0.4rem 0.8rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.8rem;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.editButton:hover:not(:disabled) {\r\n  background: rgba(74, 158, 255, 0.4);\r\n}\r\n\r\n.editButton:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.deleteProviderButton {\r\n  background: rgba(244, 67, 54, 0.2);\r\n  border: 1px solid rgba(244, 67, 54, 0.4);\r\n  color: #f44336;\r\n  padding: 0.4rem 0.8rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.8rem;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.deleteProviderButton:hover:not(:disabled) {\r\n  background: rgba(244, 67, 54, 0.4);\r\n}\r\n\r\n.noProviders {\r\n  color: #888;\r\n  font-style: italic;\r\n  text-align: center;\r\n  padding: 1rem;\r\n}\r\n\r\n.addProviderButton {\r\n  background: rgba(74, 158, 255, 0.2);\r\n  border: 1px dashed rgba(74, 158, 255, 0.5);\r\n  color: #4a9eff;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n\r\n.addProviderButton:hover {\r\n  background: rgba(74, 158, 255, 0.3);\r\n  border-style: solid;\r\n}\r\n\r\n.addProviderForm {\r\n  background: rgba(0, 0, 0, 0.2);\r\n  border: 1px solid rgba(74, 158, 255, 0.3);\r\n  border-radius: 6px;\r\n  padding: 1.5rem;\r\n}\r\n\r\n.addProviderForm h4 {\r\n  margin: 0 0 1rem 0;\r\n  color: #4a9eff;\r\n  font-size: 1rem;\r\n}\r\n\r\n.formButtons {\r\n  display: flex;\r\n  gap: 1rem;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.formButtons .createButton {\r\n  flex: 1;\r\n}\r\n\r\n.cancelButton {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  color: #ccc;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.cancelButton:hover {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  color: white;\r\n}\r\n\r\n/* Closing animations */\r\n.overlay.closing {\r\n  animation: fadeOut 0.15s ease-in forwards;\r\n}\r\n\r\n.modal.closing {\r\n  animation: modalContentFadeOut 0.15s ease-in forwards;\r\n}\r\n\r\n/* AI Prompts Section Styles */\r\n.aiPromptButtons {\r\n  display: flex;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.aiPromptButton {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  background: rgba(40, 40, 40, 0.8);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  color: white;\r\n  padding: 0.75rem 1.25rem;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.aiPromptButton:hover {\r\n  background: rgba(74, 158, 255, 0.2);\r\n  border-color: #4a9eff;\r\n}\r\n\r\n.aiPromptButton i {\r\n  font-size: 1.1rem;\r\n  color: #4a9eff;\r\n}\r\n\r\n.customBadge {\r\n  background: #4a9eff;\r\n  color: white;\r\n  font-size: 0.7rem;\r\n  padding: 0.2rem 0.5rem;\r\n  border-radius: 10px;\r\n  margin-left: 0.5rem;\r\n}\r\n\r\n/* AI Prompt Edit Modal */\r\n.promptModalOverlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.85);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1100;\r\n  animation: fadeIn 0.15s ease-out forwards;\r\n}\r\n\r\n.promptModal {\r\n  background: rgba(24, 26, 27, 0.98);\r\n  backdrop-filter: blur(15px);\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.8);\r\n  border: 1px solid rgba(255, 255, 255, 0.15);\r\n  width: 90%;\r\n  max-width: 900px;\r\n  max-height: 85vh;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  color: white;\r\n  animation: modalContentFadeIn 0.2s ease-out forwards;\r\n}\r\n\r\n.promptModalHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 1.25rem 1.5rem;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\r\n  background: rgba(30, 30, 30, 0.7);\r\n}\r\n\r\n.promptModalHeader h3 {\r\n  margin: 0;\r\n  font-size: 1.25rem;\r\n  color: #4a9eff;\r\n  font-weight: 600;\r\n}\r\n\r\n.promptModalContent {\r\n  flex: 1;\r\n  padding: 1.5rem;\r\n  overflow-y: auto;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;\r\n}\r\n\r\n.promptModalContent::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.promptModalContent::-webkit-scrollbar-track {\r\n  background: rgba(0, 0, 0, 0.2);\r\n  border-radius: 3px;\r\n}\r\n\r\n.promptModalContent::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.3);\r\n  border-radius: 3px;\r\n}\r\n\r\n.defaultPromptSection,\r\n.customPromptSection {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.defaultPromptSection label,\r\n.customPromptSection label {\r\n  display: block;\r\n  margin-bottom: 0.75rem;\r\n  font-weight: 500;\r\n  color: #ccc;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.defaultPromptText {\r\n  background: rgba(0, 0, 0, 0.4);\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n  border-radius: 6px;\r\n  padding: 1rem;\r\n  font-family: 'Consolas', 'Monaco', monospace;\r\n  font-size: 0.8rem;\r\n  line-height: 1.5;\r\n  color: #aaa;\r\n  white-space: pre-wrap;\r\n  word-wrap: break-word;\r\n  max-height: 200px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.customPromptTextarea {\r\n  width: 100%;\r\n  padding: 1rem;\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  border-radius: 6px;\r\n  background-color: rgba(0, 0, 0, 0.3);\r\n  color: white;\r\n  font-size: 0.9rem;\r\n  font-family: inherit;\r\n  line-height: 1.5;\r\n  resize: vertical;\r\n  min-height: 120px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.customPromptTextarea:focus {\r\n  outline: none;\r\n  border-color: #4a9eff;\r\n  box-shadow: 0 0 0 2px rgba(74, 158, 255, 0.2);\r\n}\r\n\r\n.customPromptTextarea::placeholder {\r\n  color: rgba(255, 255, 255, 0.4);\r\n}\r\n\r\n.promptHint {\r\n  margin-top: 0.5rem;\r\n  font-size: 0.8rem;\r\n  color: #888;\r\n  font-style: italic;\r\n}\r\n\r\n.promptModalFooter {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 1rem;\r\n  padding: 1.25rem 1.5rem;\r\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\r\n  background: rgba(30, 30, 30, 0.7);\r\n}\r\n\r\n.savePromptButton {\r\n  background: #4a9eff;\r\n  border: none;\r\n  color: white;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.savePromptButton:hover {\r\n  background: #3a8aff;\r\n}\r\n\r\n.savePromptButton:disabled,\r\n.promptModalFooter .cancelButton:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* External API Key Section Styles */\r\n.apiKeyContainer {\r\n  background: rgba(40, 40, 40, 0.5);\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n  border-radius: 6px;\r\n  padding: 1.25rem;\r\n}\r\n\r\n.apiKeyStatus {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.apiKeyLabel {\r\n  color: #ccc;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.apiKeyActive {\r\n  color: #4caf50;\r\n  font-weight: 500;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.apiKeyInactive {\r\n  color: #888;\r\n  font-style: italic;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.generatedKeyBox {\r\n  background: rgba(155, 89, 182, 0.15);\r\n  border: 1px solid rgba(155, 89, 182, 0.3);\r\n  border-radius: 6px;\r\n  padding: 1rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.generatedKeyLabel {\r\n  margin: 0 0 0.75rem 0;\r\n  color: #9B59B6;\r\n  font-weight: 500;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.generatedKeyValue {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  background: rgba(0, 0, 0, 0.3);\r\n  padding: 0.75rem;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n}\r\n\r\n.generatedKeyValue code {\r\n  flex: 1;\r\n  font-family: 'Consolas', 'Monaco', monospace;\r\n  font-size: 0.85rem;\r\n  color: #fff;\r\n  word-break: break-all;\r\n  user-select: all;\r\n}\r\n\r\n.copyButton {\r\n  background: rgba(155, 89, 182, 0.3);\r\n  border: 1px solid rgba(155, 89, 182, 0.5);\r\n  color: #9B59B6;\r\n  padding: 0.5rem 0.75rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  transition: all 0.2s;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.copyButton:hover {\r\n  background: rgba(155, 89, 182, 0.5);\r\n  color: white;\r\n}\r\n\r\n.generateKeyButton {\r\n  background: rgba(155, 89, 182, 0.3);\r\n  border: 1px solid rgba(155, 89, 182, 0.5);\r\n  color: #9B59B6;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n  width: 100%;\r\n}\r\n\r\n.generateKeyButton:hover:not(:disabled) {\r\n  background: rgba(155, 89, 182, 0.5);\r\n  color: white;\r\n}\r\n\r\n.generateKeyButton:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .aiPromptButtons {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .aiPromptButton {\r\n    width: 100%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .promptModal {\r\n    width: 95%;\r\n    max-height: 90vh;\r\n  }\r\n\r\n  .promptModalHeader,\r\n  .promptModalContent,\r\n  .promptModalFooter {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .generatedKeyValue {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .generatedKeyValue code {\r\n    margin-bottom: 0.5rem;\r\n  }\r\n\r\n  .copyButton {\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `UserSettingsModal_overlay__+c5hY`,
	"fadeIn": `UserSettingsModal_fadeIn__MxgQN`,
	"modal": `UserSettingsModal_modal__KWQur`,
	"modalContentFadeIn": `UserSettingsModal_modalContentFadeIn__F2xV0`,
	"header": `UserSettingsModal_header__2pvpq`,
	"closeButton": `UserSettingsModal_closeButton__B7mbj`,
	"content": `UserSettingsModal_content__TJiPC`,
	"section": `UserSettingsModal_section__AlVW1`,
	"changePasswordButton": `UserSettingsModal_changePasswordButton__5kp+T`,
	"createUserForm": `UserSettingsModal_createUserForm__ZC6HP`,
	"inputGroup": `UserSettingsModal_inputGroup__4tJf5`,
	"createButton": `UserSettingsModal_createButton__8NQ06`,
	"usersList": `UserSettingsModal_usersList__wGh6u`,
	"usersHeader": `UserSettingsModal_usersHeader__CbtvE`,
	"userRow": `UserSettingsModal_userRow__FWDiZ`,
	"username": `UserSettingsModal_username__s5Ftb`,
	"role": `UserSettingsModal_role__s+y33`,
	"adminRole": `UserSettingsModal_adminRole__nMz6T`,
	"userRole": `UserSettingsModal_userRole__cNzPh`,
	"status": `UserSettingsModal_status__CgbQI`,
	"active": `UserSettingsModal_active__QU33v`,
	"inactive": `UserSettingsModal_inactive__FpWKH`,
	"actions": `UserSettingsModal_actions__Msmko`,
	"actionButton": `UserSettingsModal_actionButton__vBW6q`,
	"activateButton": `UserSettingsModal_activateButton__s+EVp`,
	"deactivateButton": `UserSettingsModal_deactivateButton__P+MSC`,
	"deleteButton": `UserSettingsModal_deleteButton__Eh94n`,
	"error": `UserSettingsModal_error__kjlCR`,
	"success": `UserSettingsModal_success__kEugN`,
	"footer": `UserSettingsModal_footer__kDQYK`,
	"closeFooterButton": `UserSettingsModal_closeFooterButton__Gigq2`,
	"backgroundGrid": `UserSettingsModal_backgroundGrid__ADEcM`,
	"backgroundItem": `UserSettingsModal_backgroundItem__B2oGv`,
	"selected": `UserSettingsModal_selected__62lsG`,
	"backgroundPreview": `UserSettingsModal_backgroundPreview__LZSBI`,
	"backgroundName": `UserSettingsModal_backgroundName__mdC9R`,
	"selectedBadge": `UserSettingsModal_selectedBadge__8+iWD`,
	"brightnessControl": `UserSettingsModal_brightnessControl__MtofI`,
	"brightnessSlider": `UserSettingsModal_brightnessSlider__uy6G4`,
	"brightnessValue": `UserSettingsModal_brightnessValue__7BWzn`,
	"brightnessHint": `UserSettingsModal_brightnessHint__StC0U`,
	"sectionHint": `UserSettingsModal_sectionHint__dHDYG`,
	"zohoEmailContainer": `UserSettingsModal_zohoEmailContainer__cxIg4`,
	"zohoEmailInput": `UserSettingsModal_zohoEmailInput__vSvUo`,
	"zohoEmailButton": `UserSettingsModal_zohoEmailButton__4VtpG`,
	"zohoEmailStatus": `UserSettingsModal_zohoEmailStatus__K3sPL`,
	"zohoConfigStatus": `UserSettingsModal_zohoConfigStatus__J8Lom`,
	"zohoConfigStatusOk": `UserSettingsModal_zohoConfigStatusOk__E-r-F`,
	"zohoConfigStatusError": `UserSettingsModal_zohoConfigStatusError__kUeU7`,
	"zohoButtonRow": `UserSettingsModal_zohoButtonRow__3h2uc`,
	"llmSettings": `UserSettingsModal_llmSettings__ZpLDc`,
	"llmModeSection": `UserSettingsModal_llmModeSection__qs6sJ`,
	"checkboxLabel": `UserSettingsModal_checkboxLabel__QOYrA`,
	"llmSubsection": `UserSettingsModal_llmSubsection__1XS0A`,
	"testButton": `UserSettingsModal_testButton__0PzT2`,
	"apiKeyDisplay": `UserSettingsModal_apiKeyDisplay__uv3zM`,
	"maskedKey": `UserSettingsModal_maskedKey__0warg`,
	"removeKeyButton": `UserSettingsModal_removeKeyButton__Ns2D3`,
	"saveLLMButton": `UserSettingsModal_saveLLMButton__KnisQ`,
	"providerList": `UserSettingsModal_providerList__tQQxJ`,
	"providerItem": `UserSettingsModal_providerItem__mBZOl`,
	"activeProvider": `UserSettingsModal_activeProvider__8YFM0`,
	"providerInfo": `UserSettingsModal_providerInfo__9NaZb`,
	"providerName": `UserSettingsModal_providerName__vE8W3`,
	"activeBadge": `UserSettingsModal_activeBadge__GXWCy`,
	"providerDetails": `UserSettingsModal_providerDetails__nOdRm`,
	"providerActions": `UserSettingsModal_providerActions__ZODFE`,
	"editButton": `UserSettingsModal_editButton__qCJaX`,
	"deleteProviderButton": `UserSettingsModal_deleteProviderButton__p-ikH`,
	"noProviders": `UserSettingsModal_noProviders__QmQL2`,
	"addProviderButton": `UserSettingsModal_addProviderButton__95cu0`,
	"addProviderForm": `UserSettingsModal_addProviderForm__wuOOI`,
	"formButtons": `UserSettingsModal_formButtons__TlGob`,
	"cancelButton": `UserSettingsModal_cancelButton__r3tO5`,
	"closing": `UserSettingsModal_closing__NU-wB`,
	"fadeOut": `UserSettingsModal_fadeOut__fWUeo`,
	"modalContentFadeOut": `UserSettingsModal_modalContentFadeOut__8Rt0a`,
	"aiPromptButtons": `UserSettingsModal_aiPromptButtons__Anmui`,
	"aiPromptButton": `UserSettingsModal_aiPromptButton__+VtYn`,
	"customBadge": `UserSettingsModal_customBadge__knoup`,
	"promptModalOverlay": `UserSettingsModal_promptModalOverlay__ifR91`,
	"promptModal": `UserSettingsModal_promptModal__aKFVp`,
	"promptModalHeader": `UserSettingsModal_promptModalHeader__LX-0t`,
	"promptModalContent": `UserSettingsModal_promptModalContent__D9qza`,
	"defaultPromptSection": `UserSettingsModal_defaultPromptSection__KD4x6`,
	"customPromptSection": `UserSettingsModal_customPromptSection__iuqVZ`,
	"defaultPromptText": `UserSettingsModal_defaultPromptText__+Az-D`,
	"customPromptTextarea": `UserSettingsModal_customPromptTextarea__C7EYP`,
	"promptHint": `UserSettingsModal_promptHint__tc0pW`,
	"promptModalFooter": `UserSettingsModal_promptModalFooter__42UST`,
	"savePromptButton": `UserSettingsModal_savePromptButton__ruZIk`,
	"apiKeyContainer": `UserSettingsModal_apiKeyContainer__alnpi`,
	"apiKeyStatus": `UserSettingsModal_apiKeyStatus__coBah`,
	"apiKeyLabel": `UserSettingsModal_apiKeyLabel__h8rdQ`,
	"apiKeyActive": `UserSettingsModal_apiKeyActive__T0sBO`,
	"apiKeyInactive": `UserSettingsModal_apiKeyInactive__yxiKN`,
	"generatedKeyBox": `UserSettingsModal_generatedKeyBox__A14ll`,
	"generatedKeyLabel": `UserSettingsModal_generatedKeyLabel__LZNzx`,
	"generatedKeyValue": `UserSettingsModal_generatedKeyValue__+Ni-e`,
	"copyButton": `UserSettingsModal_copyButton__OAliP`,
	"generateKeyButton": `UserSettingsModal_generateKeyButton__Bcx+M`
};
export default ___CSS_LOADER_EXPORT___;
